import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { PathModuleFutureRegistration } from '../../../services/component-data-source/data/event/event-participate-path-module-hints.util';

export interface ParticipatePathModuleFutureDialogData {
  items: PathModuleFutureRegistration[];
}

@Component({
  selector: 'app-participate-path-module-future-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <h2 mat-dialog-title>Fremtidig tilmelding med samme modul</h2>
    <mat-dialog-content class="dialog-content">
      <p>
        Du er allerede tilmeldt et <strong>fremtidigt</strong> event med mindst ét
        modul, som også findes på dette event og på din uddannelsesvej. Du har
        <strong>ikke gennemført modulet</strong> endnu i den nuværende
        vedligeholdelsesperiode.
      </p>
      <ul>
        @for (item of data.items; track item.moduleId + item.eventDate) {
          <li>
            <strong>{{ item.moduleName }}</strong> ({{ item.pathName }}) —
            tilmeldt «{{ item.eventName }}»
            ({{ formatDate(item.eventDate) }})
          </li>
        }
      </ul>
      <p>Du kan stadig tilmelde dig her, hvis du ønsker det.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" (click)="close()">Forstået</button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .dialog-content {
        max-width: 32rem;
        line-height: 1.45;
      }
      ul {
        margin: 0.75rem 0;
        padding-left: 1.25rem;
      }
    `,
  ],
})
export class ParticipatePathModuleFutureDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ParticipatePathModuleFutureDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: ParticipatePathModuleFutureDialogData
  ) {}

  formatDate(iso: string): string {
    const d = Date.parse(iso);
    if (!Number.isFinite(d)) {
      return iso;
    }
    return new Date(d).toLocaleDateString('da-DK');
  }

  close(): void {
    this.dialogRef.close();
  }
}
